import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { CustomButton } from "../../../components";

// ==================== SECTION CARD WRAPPER ====================
const SectionCard = ({ icon, title, children }) => (
  <div
    style={{
      marginBottom: "20px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      overflow: "hidden",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "12px 16px",
        backgroundColor: "#f5f7ff",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      {/* <span style={{ fontSize: "16px" }}>{icon}</span> */}
      <span style={{ fontWeight: 700, fontSize: "15px", color: "#1a237e" }}>
        {title}
      </span>
    </div>

    {/* Header */}
    <div
      style={{
        display: "flex",
        backgroundColor: "#e8edf8",
        borderBottom: "1px solid #dde3f0",
      }}
    >
      <div
        style={{
          flex: "0 0 45%",
          padding: "8px 16px",
          fontWeight: 700,
          fontSize: "13px",
        }}
      >
        Field
      </div>
      <div
        style={{
          flex: "0 0 55%",
          padding: "8px 16px",
          fontWeight: 700,
          fontSize: "13px",
        }}
      >
        Value
      </div>
    </div>

    {/* Rows */}
    <div>{children}</div>
  </div>
);

// ==================== PREVIEW ROW ====================
const PreviewRow = ({ label, value }) => {
  // if (value === null || value === undefined || value === "") return null;
  return (
    <div style={{ display: "flex", borderBottom: "1px solid #f0f0f0" }}>
      <div
        style={{
          flex: "0 0 45%",
          padding: "9px 16px",
          fontWeight: 600,
          fontSize: "13px",
          backgroundColor: "#fafbff",
          verticalAlign: "top",
        }}
      >
        {label}
      </div>
      <div
        style={{
          flex: "0 0 55%",
          padding: "9px 16px",
          fontSize: "13px",
          wordBreak: "break-word",
          whiteSpace: "normal",
          overflowWrap: "break-word",
        }}
      >
        {value || "-"}
      </div>
    </div>
  );
};

// ==================== MARKS TABLE ====================
const MarksTableSection = ({ title, formData, t }) => {
  const subjects = [
    { label: "TAMIL", value: formData.tamil_mark },
    { label: "ENGLISH", value: formData.english_mark },
    { label: "MATHS", value: formData.mathematics_mark },
    { label: "SCIENCE", value: formData.science_mark },
    { label: "SOCIAL SCIENCE", value: formData.social_science_mark },
  ];
  return (
    <div
      style={{
        marginBottom: "20px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "12px 16px",
          backgroundColor: "#f5f7ff",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <span style={{ fontSize: "16px" }}>📊</span>
        <span style={{ fontWeight: 700, fontSize: "15px", color: "#1a237e" }}>
          {title}
        </span>
      </div>
      <div
        style={{
          width: "100%",
          border: "1px solid #dde3f0",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        {/* Header Row */}
        <div
          style={{
            display: "flex",
            backgroundColor: "#e8edf8",
            borderBottom: "1px solid #dde3f0",
          }}
        >
          <div
            style={{
              flex: "60%",
              padding: "8px 16px",
              fontWeight: 700,
              fontSize: "13px",
            }}
          >
            {t?.subject || "Subject"}
          </div>
          <div
            style={{
              flex: "40%",
              padding: "8px 16px",
              fontWeight: 700,
              fontSize: "13px",
              textAlign: "center",
            }}
          >
            {t?.marksObtained || "Marks Obtained"}
          </div>
        </div>

        {/* Subject Rows */}
        {subjects.map(({ label, value }) => (
          <div
            key={label}
            style={{ display: "flex", borderBottom: "1px solid #f0f0f0" }}
          >
            <div style={{ flex: "60%", padding: "8px 16px", fontSize: "13px" }}>
              {label}
            </div>
            <div
              style={{
                flex: "40%",
                padding: "8px 16px",
                fontSize: "13px",
                textAlign: "center",
                wordBreak: "break-word",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              {value}
            </div>
          </div>
        ))}

        {/* Total Row */}
        <div
          style={{
            display: "flex",
            backgroundColor: "#f5f5f5",
            borderBottom: "1px solid #e0e0e0",
            fontWeight: 700,
          }}
        >
          <div style={{ flex: "60%", padding: "9px 16px", fontSize: "13px" }}>
            Total (Max 500)
          </div>
          <div
            style={{
              flex: "40%",
              padding: "9px 16px",
              fontSize: "13px",
              textAlign: "center",
            }}
          >
            {formData.total_mark}
          </div>
        </div>

        {/* Percentage Row */}
        <div
          style={{
            display: "flex",
            backgroundColor: "#f5f5f5",
            fontWeight: 700,
          }}
        >
          <div style={{ flex: "60%", padding: "9px 16px", fontSize: "13px" }}>
            {t?.percentage || "Percentage"}
          </div>
          <div
            style={{
              flex: "40%",
              padding: "9px 16px",
              fontSize: "13px",
              textAlign: "center",
            }}
          >
            {parseFloat(formData.total_percentage || 0).toFixed(2)} %
          </div>
        </div>
      </div>
    </div>
  );
};

// ==================== MAIN MODAL COMPONENT ====================
const ModalXII = ({
  open,
  onClose,
  formData,
  onSubmit,
  submitting,
  handleVerifyApplication,
  generatedOtp,
  otpInputRef,
}) => {
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations]);

  const [agreed, setAgreed] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);

  // Confirm & Submit enabled only when checkbox ticked AND OTP verified
  const canSubmit = agreed && otpVerified;

  // ← Auto-focus OTP input whenever the checkbox is ticked
  useEffect(() => {
    // Small delay lets React finish rendering the conditionally shown input
    setTimeout(() => otpInputRef.current?.focus(), 50);
  }, [agreed, otpInputRef]);

  // ---- OTP input — numbers only + live match check ----
  const handleOtpChange = (e) => {
    const raw = e.target.value;

    // Allow digits only
    if (raw !== "" && !/^\d*$/.test(raw)) return;
    // Cap at 6 digits
    const val = raw.slice(0, 6);
    setOtp(val);

    if (val.length === 0) {
      setOtpError("");
      setOtpVerified(false);
      return;
    }

    if (val.length === 6) {
      if (val === generatedOtp) {
        setOtpError("");
        setOtpVerified(true);
      } else {
        setOtpError(t?.invalidOtp || "Invalid OTP. Please try again.");
        setOtpVerified(false);
      }
    } else {
      // Still typing — clear previous error
      setOtpError("");
      setOtpVerified(false);
    }
  };

  // ---- Confirm & Submit ----
  const handleConfirmSubmit = () => {
    if (!otpVerified) {
      setOtpError(t?.invalidOtp || "Invalid OTP. Please try again.");
      return;
    }
    onSubmit(otp);
  };

  // ---- Resend OTP ----
  const handleResend = (e) => {
    setOtp("");
    setOtpError("");
    setOtpVerified(false);
    handleVerifyApplication(e);
  };

  // ---- Reset on close ----
  const handleClose = () => {
    setAgreed(false);
    setOtp("");
    setOtpError("");
    setOtpVerified(false);
    onClose();
  };

  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const getDisplayValue = (val) => {
    if (!val) return "";
    if (typeof val === "object" && val.label) return val.label;
    return val;
  };

  const getRawValue = (val) => {
    if (!val) return "";
    if (typeof val === "object" && val.value !== undefined) return val.value;
    return val;
  };

  const livingWithValue = getRawValue(formData.living_with);
  const isParent = livingWithValue === "parent";

  return (
    <Modal
      show={open}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      scrollable
    >
      {/* ---- Modal Header ---- */}
      <Modal.Header
        closeButton
        style={{
          background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
          color: "#fff",
          borderBottom: "none",
        }}
      >
        <Modal.Title
          style={{
            fontSize: "18px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {t?.applicationPreview || "Application Preview"}
        </Modal.Title>
      </Modal.Header>

      {/* ---- Modal Body ---- */}
      <Modal.Body
        style={{
          padding: "20px",
          maxHeight: "65vh",
          overflowY: "auto",
          backgroundColor: "#f8f9ff",
        }}
      >
        {/* BASIC DETAILS */}
        <SectionCard icon="" title={t?.basicDetails || "Basic Details"}>
          <PreviewRow label={t?.date || "Date"} value={formData.date} />
          <PreviewRow
            label={t?.studentNameTamil || "Student's Name (Tamil)"}
            value={formData.applicant_name_in_tamil}
          />
          <PreviewRow
            label={t?.studentNameEnglish || "Student's Name (English)"}
            value={formData.applicant_name}
          />
          <PreviewRow
            label={t?.dateOfBirth || "Date of Birth"}
            value={
              formData.date_of_birth
                ? moment(formData.date_of_birth).format("YYYY-MM-DD")
                : ""
            }
          />
          <PreviewRow
            label={t?.emailAddress || "Email"}
            value={formData.email}
          />
          <PreviewRow
            label={t?.mobileNumber || "Mobile No."}
            value={formData.mobile_number}
          />
          <PreviewRow
            label={t?.aadharNumber || "Aadhaar No."}
            value={formData.aadhar_no}
          />
          <PreviewRow
            label={t?.gender || "Gender"}
            value={getDisplayValue(formData.gender)}
          />
          <PreviewRow
            label={t?.religion || "Religion"}
            value={getDisplayValue(formData.religion)}
          />
          <PreviewRow label={t?.caste || "Caste"} value={formData.caste} />
          <PreviewRow
            label={t?.category || "Category"}
            value={getDisplayValue(formData.community)}
          />
          <PreviewRow
            label={t?.nationality || "Nationality"}
            value={formData.nationality}
          />
          <PreviewRow
            label={t?.state || "State"}
            value={getDisplayValue(formData.student_native_state)}
          />
          <PreviewRow
            label={t?.birthPlace || "Birth Place"}
            value={formData.place_of_birth}
          />
          <PreviewRow
            label={t?.communityCertificate || "Community Certificate"}
            value={formData.community_certificate_original_name}
          />
        </SectionCard>

        {/* RESIDENTIAL DETAILS */}
        <SectionCard
          icon=""
          title={t?.residentialDetails || "Residential Details"}
        >
          <PreviewRow
            label={
              t?.areYouResidingWith ||
              "Are you residing with parents or with a guardian?"
            }
            value={getDisplayValue(formData.living_with)}
          />
          <PreviewRow
            label={t?.fullname || "Name"}
            value={isParent ? formData.parent_name : formData.guardian_name}
          />
          <PreviewRow
            label={t?.occupation || "Occupation"}
            value={
              isParent
                ? getDisplayValue(formData.parent_occupation)
                : getDisplayValue(formData.guardian_occupation)
            }
          />
          <PreviewRow
            label={t?.annualIncome || "Annual Income"}
            value={
              isParent
                ? formData.parent_annual_salary
                : formData.guardian_annual_salary
            }
          />
          <PreviewRow
            label={t?.address || "Address"}
            value={
              isParent ? formData.parent_address : formData.guardian_address
            }
          />
          <PreviewRow
            label={t?.district || "District"}
            value={
              isParent ? formData.parent_district : formData.guardian_district
            }
          />
          <PreviewRow
            label={t?.taluk || "Taluk"}
            value={isParent ? formData.parent_city : formData.guardian_city}
          />
          <PreviewRow
            label={t?.state || "State"}
            value={
              isParent
                ? getDisplayValue(formData.parent_state)
                : getDisplayValue(formData.guardian_state)
            }
          />
          <PreviewRow
            label={t?.pincode || "Pincode"}
            value={
              isParent ? formData.parent_pincode : formData.guardian_pincode
            }
          />
        </SectionCard>

        {/* ACADEMIC DETAILS */}
        <SectionCard icon="" title={t?.academicDetails || "Academic Details"}>
          <PreviewRow
            label={
              t?.qualifyingExaminationPassed || "Qualifying Examination Passed"
            }
            value={getDisplayValue(formData.qualified_eligibility_exam)}
          />
          <PreviewRow
            label={t?.nameOfExaminationBoard || "Name of the Examination Board"}
            value={getDisplayValue(formData.exam_board_name)}
          />
        </SectionCard>

        {/* MARKS */}
        <SectionCard
          icon=""
          title={t?.publicExaminationMarks || "Public Examination Marks"}
        >
          <PreviewRow
            label={t?.nameOfExaminationPassed || "Name of Examination Passed"}
            value={getDisplayValue(formData.qualified_exam_name)}
          />
          <PreviewRow
            label={t?.monthAndYearOfExamination || "Month & Year of Appearing"}
            value={formData.exam_month_and_year}
          />
          <PreviewRow
            label={t?.examinationRegisterNumber || "Register Number"}
            value={formData.register_number}
          />
        </SectionCard>

        {/* MARKS TABLE */}
        <MarksTableSection
          title={t?.marksTable || "Marks Table"}
          formData={formData}
          t={t}
        />

        {/* PREFERRED COURSE DETAILS */}
        <SectionCard
          icon=""
          title={t?.preferredCourseDetails || "Preferred Course Details"}
        >
          <PreviewRow
            label={t?.preferredStudyCourse || "Course Preferred to Study"}
            value={getDisplayValue(formData.preferred_study_course)}
          />
          <PreviewRow
            label={t?.yearOfAdmission || "Year of Admission"}
            value={getDisplayValue(formData.admission_for_which_year)}
          />
          <PreviewRow
            label={t?.preferredGroup1 || "Preferred Group 1"}
            value={getDisplayValue(formData.preferred_group_1)}
          />
          <PreviewRow
            label={t?.preferredGroup2 || "Preferred Group 2"}
            value={getDisplayValue(formData.preferred_group_2)}
          />
          <PreviewRow
            label={t?.preferredGroup3 || "Preferred Group 3"}
            value={getDisplayValue(formData.preferred_group_3)}
          />
          <PreviewRow
            label={t?.motherTongue || "Mother Tongue"}
            value={getDisplayValue(formData.mother_tongue)}
          />
          <PreviewRow
            label={
              t?.mediumOfInstructionLeavingSchool ||
              "Medium of Instruction at the Time of Leaving School"
            }
            value={formData.last_medium_of_instruction}
          />
        </SectionCard>

        {/* LAST STUDIED DETAILS */}
        <SectionCard
          icon=""
          title={t?.lastStudiedDetails || "Last Studied Details"}
        >
          <PreviewRow
            label={t?.lastStudiedClass || "Last Studied Class"}
            value={getDisplayValue(formData.last_studied_class)}
          />
          <PreviewRow
            label={t?.studiedYear || "Year of Study"}
            value={formData.studied_year}
          />
          <PreviewRow
            label={t?.lastStudiedSchool || "Name of the Last Studied School"}
            value={formData.last_studied_school_name}
          />
          <PreviewRow
            label={t?.emisNo || "EMIS No."}
            value={formData.emis_id}
          />
          <PreviewRow
            label={
              t?.reasonForLeaving || "Reason for Leaving or Discontinuation"
            }
            value={formData.reason_for_discontinuing}
          />
        </SectionCard>

        {/* OTHER DETAILS */}
        <SectionCard icon="" title={t?.otherDetails || "Other Details"}>
          <PreviewRow
            label={
              t?.nccNssScoutsGuides ||
              "NCC / NSS / Scouts / Guides / Red Cross – Would you like to join?"
            }
            value={formData.willing_to_join_services}
          />
          <PreviewRow
            label={t?.smallpoxVaccinationTaken || "Smallpox Vaccination Taken?"}
            value={formData.is_vaccinated_pox}
          />
          <PreviewRow label={t?.place || "Place"} value={formData.place} />
          <PreviewRow
            label={t?.studentImage || "Student Image"}
            value={formData.student_image_original_name}
          />
        </SectionCard>

        {/* ======= PARENT / GUARDIAN PLEDGE ======= */}
        <div
          style={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            overflow: "hidden",
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              padding: "14px 20px",
              backgroundColor: "#f5a623",
              borderBottom: "1px solid #e09000",
            }}
          >
            <span
              style={{ fontWeight: 700, fontSize: "15px", color: "#1a1a1a" }}
            >
              {t?.parentGuardianPledge || "Parent / Guardian Pledge"}
            </span>
          </div>
          <div style={{ padding: "20px 24px" }}>
            <p
              style={{
                fontSize: "13px",
                lineHeight: 1.7,
                color: "#333",
                marginBottom: "12px",
              }}
            >
              {t?.pledgeLine1 ||
                "I hereby declare that the particulars furnished above are true and correct to the best of my knowledge, and that I shall abide by the rules and regulations of the school."}
            </p>
            <p
              style={{
                fontSize: "13px",
                lineHeight: 1.7,
                color: "#333",
                marginBottom: "12px",
              }}
            >
              {t?.pledgeLine2 ||
                "I am aware that if the admission is found to have been obtained based on false information or by suppressing facts, it is liable to be cancelled at any time."}
            </p>
            <p
              style={{
                fontSize: "13px",
                lineHeight: 1.7,
                color: "#333",
                marginBottom: "16px",
              }}
            >
              {t?.pledgeLine3 ||
                "I further undertake to follow the school discipline, and in case of any violation, I agree to apply for and obtain the Transfer Certificate."}
            </p>
            <p
              style={{
                fontSize: "13px",
                fontWeight: 700,
                marginBottom: "6px",
                color: "#333",
              }}
            >
              {t?.pledgeNote || "Note:"}
            </p>
            <p style={{ fontSize: "13px", color: "#333", margin: "0 0 4px 0" }}>
              1.{" "}
              {t?.pledgeNote1 ||
                "Submit originals at the time of admission and keep photocopies."}
            </p>
            <p
              style={{ fontSize: "13px", color: "#333", margin: "0 0 20px 0" }}
            >
              2.{" "}
              {t?.pledgeNote2 ||
                "Certificates will not be returned once the student leaves school."}
            </p>

            {/* ---- Checkbox ---- */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "20px",
              }}
            >
              <input
                type="checkbox"
                id="agreeCheckboxXII"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                style={{
                  width: "18px",
                  height: "18px",
                  accentColor: "#1565c0",
                  cursor: "pointer",
                }}
              />
              <label
                htmlFor="agreeCheckboxXII"
                style={{ fontSize: "14px", fontWeight: 600, cursor: "pointer" }}
              >
                {t?.iAgreeToAboveStatements ||
                  "I have read and agree to the above statements."}
              </label>
            </div>

            {/* ---- OTP Section — shown only after checkbox ticked ---- */}
            {/* {agreed && ( */}
            <div
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                padding: "16px 20px",
                backgroundColor: "#fafafa",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  marginBottom: "12px",
                }}
              >
                {t?.enterOtpSentToEmail ||
                  "Enter the 6-digit OTP sent to your email"}
              </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                {/* OTP input — numbers only, max 6, live match */}
                <div style={{ maxWidth: "200px" }}>
                  <input
                    ref={otpInputRef}
                    name="otp"
                    type="text"
                    inputMode="numeric"
                    value={otp}
                    onChange={handleOtpChange}
                    placeholder="------"
                    maxLength={6}
                    style={{
                      width: "100%",
                      padding: "8px 12px",
                      border: otpError
                        ? "1px solid #d32f2f"
                        : otpVerified
                          ? "1px solid #2e7d32"
                          : "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "20px",
                      letterSpacing: "6px",
                      textAlign: "center",
                      outline: "none",
                      fontWeight: 600,
                    }}
                  />
                  {/* Error message */}
                  {otpError && (
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {otpError}
                    </div>
                  )}
                  {/* Success indicator */}
                  {otpVerified && (
                    <div
                      style={{
                        color: "#2e7d32",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {t?.otpVerified || "✓ OTP verified"}
                    </div>
                  )}
                </div>

                {/* Resend OTP */}
                <CustomButton
                  type="button"
                  variant="outlined"
                  onClick={handleResend}
                  fullWidth={false}
                >
                  {t?.resendOtp || "Resend OTP"}
                </CustomButton>
              </div>
            </div>
            {/* // )} */}
          </div>
        </div>
      </Modal.Body>

      {/* ---- Modal Footer ---- */}
      <Modal.Footer
        style={{
          borderTop: "1px solid #e0e0e0",
          padding: "12px 20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
        }}
      >
        <CustomButton
          type="button"
          variant="contained"
          onClick={handleClose}
          fullWidth={false}
          style={{
            backgroundColor: "#555",
            color: "#fff",
            padding: "8px 24px",
          }}
        >
          {t?.edit || "Edit"}
        </CustomButton>

        {/* Confirm & Submit — enabled only when checkbox ticked AND OTP verified */}
        <CustomButton
          type="button"
          variant="contained"
          onClick={handleConfirmSubmit}
          fullWidth={false}
          loading={submitting}
          disabled={!canSubmit || submitting}
          style={{
            backgroundColor: canSubmit ? "#2e7d32" : "#9e9e9e",
            color: "#fff",
            padding: "8px 24px",
            cursor: canSubmit ? "pointer" : "not-allowed",
          }}
        >
          {t?.confirmAndSubmit || "Confirm & Submit"}
        </CustomButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalXII;
